<script setup lang="ts">
import { useField } from 'vee-validate';
import Textarea from './Textarea.vue';
import type { VeeTextareaProps } from '../types';
import { toRef, computed } from 'vue';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeTextareaProps>();

const veeProps = useVeeFormProps(props);

const { errorMessage, value, handleChange, handleBlur, meta } = useField<string | undefined>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: false,
  },
);

function onUpdate(input: string | undefined) {
  // An empty API value is null. The textarea reports that as "", which normalizes to undefined.
  if (input === value.value || (input == null && value.value == null)) return;
  handleChange(input, meta.touched);
}

function onBlur(event: FocusEvent) {
  handleBlur(event, true);
}

const modelValue = computed(() =>
  value.value && props.outputConverter && veeProps.value.mode === 'details'
    ? props.outputConverter(value.value)
    : value.value,
);
</script>

<template>
  <Textarea
    v-bind="veeProps"
    :modelValue="modelValue"
    :errorMessage="errorMessage"
    @update:modelValue="onUpdate"
    @blur="onBlur"
  />
</template>
